export const BalanceQuery = {
    queryKey: (address, token) => ['balance', address, token],
    queryFn: async (blockchainService, address, token) => {
        if (!address) {
            return 0n;
        }
        return await blockchainService.getBalance(address, token);
    },
};
//# sourceMappingURL=balance.js.map